import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReRouteRoutingModule } from './re-route-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { ReRouteLayoutComponent } from './components/re-route-layout/re-route-layout.component';
import { ReRouteMainContainerComponent } from './components/re-route-main-container/re-route-main-container.component';
import { SearchResultModule } from '../search-result/search-result.module';
import { EffectsModule } from '@ngrx/effects';
import {
  SpinnerModule,
  TabsModule,
  PassengersModule,
  StepperModule,
  InputSubmitModule,
  AlertModule,
  RemarksModule,
  TitleModule,
  InputSelectAddonModule,
  InputFieldModule,
  InputSelectModule,
  ModalModule,
  DateRangeModule,
  ItineraryResumeModule
} from '../components';
import { ReRouteEffects } from './store/effects/re-route.effects';
import { PassengerDocsaInformationModule } from '../components/passenger-docsa-Information/passenger-docsa-information.module';
import { ReRouteAPIService } from './services/re-route.api.service';
import { RemarksEffects } from '../search-result/effects/remarks.effects';
import { ReactiveFormsModule } from '@angular/forms';
import { ReRouteModalModule } from './components/re-route-modal/re-route-modal.module';
import { PassengerInformationReRouteFormComponent } from './components/form-passengerInformation/passenger-form.component';
import { ReRouteSplitStepModule } from './components/re-route-main-container/components/re-route-split-step/re-route-split-step.module';

@NgModule({
  declarations: [
    ReRouteLayoutComponent,
    ReRouteMainContainerComponent,
    PassengerInformationReRouteFormComponent
  ],
  imports: [
    CommonModule,
    ReRouteRoutingModule,
    SearchResultModule,
    TitleModule,
    TranslateModule,
    SpinnerModule,
    InputFieldModule,
    InputSelectModule,
    InputSelectAddonModule,
    ReactiveFormsModule,
    PassengerDocsaInformationModule,
    ItineraryResumeModule,
    ReRouteSplitStepModule,
    ModalModule,
    DateRangeModule,
    StepperModule,
    InputSubmitModule,
    TabsModule,
    PassengersModule,
    AlertModule,
    RemarksModule,
    ReRouteModalModule,
    EffectsModule.forFeature([ReRouteEffects, RemarksEffects])
  ],
  providers: [ReRouteAPIService]
})
export class ReRouteModule {}
